import React from 'react';
import { EditableField } from '../../components/EditableField';
import { type Slide } from '../../_data';
import { Grid, Typography } from '@mui/material';
// import ModelSetSlideTable from '../../components/ModelSetSlideTable';
import { getSlideField } from '../../utils';
import Footer from '../Footer';
import { useSlidePageNumber } from '../../useSlidePageNumber';
// import SplitModelSetSlideTable from 'components/SplitModelSetSlideTable';
// import { PremiumReportModelSetSlideTable } from 'components/SplitModelSetSlideTable/wrappers';
import SplitModelSetSlideTable from 'components/SplitModelSetSlideTable';

export type Slide5ContentType = [
  {
    field: 'title';
    label: string;
    value: string;
    type: 'editableTextarea';
  },
  {
    field: 'subtitle1';
    label: string;
    value: string;
    type: 'editableTextarea';
  },
  {
    field: 'modelSet';
    label: string;
    value: string;
    type: 'modelSet';
  },
];

export const Slide5Content = React.memo(
  ({
    slide,
    onChangeSlide,
  }: {
    slide: Slide<Slide5ContentType>;
    onChangeSlide: (
      slide: Slide<Slide5ContentType>,
      content: Slide5ContentType,
    ) => void;
  }): React.ReactElement => {
    const pageNumber = useSlidePageNumber(slide);

    return (
      <Grid
        container
        sx={{
          padding: '12px 12px 0 12px',
          height: '100%',
          width: '100%',
          fontFamily: 'Roboto',
        }}
      >
        <Grid
          container
          gap={2}
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
            height: 'calc(100% - 100px)',
          }}
          className="slide5-container"
        >
          <Grid
            item
            sx={{
              padding: '17px 28px 0px 28px',
              backgroundColor: '#DEE8F2',
              width: '40%',
              height: 'fit-content',
              '& h2 span': {
                fontSize: '18px !important',
              },
              '& ul': {
                marginBlock: '0rem',
                paddingLeft: '1.5rem',
              },
            }}
          >
            <Grid item height="fit-content" paddingBottom="22px">
              <EditableField
                field={'title'}
                slide={slide}
                onSlideContentChange={onChangeSlide}
                style={{
                  // Note: Don't set fontSize here, it will be set by the fieldData fontSize
                  // We have added the ability to set the fontSize in the editor
                  color: '#004F7E',
                  fontFamily: 'Roboto',
                  fontWeight: '500',
                }}
                editorClassName="slide5"
              />
            </Grid>
            <Grid item height="fit-content">
              <EditableField
                field={'subtitle1'}
                slide={slide}
                onSlideContentChange={onChangeSlide}
                style={{
                  // Note: Don't set fontSize here, it will be set by the fieldData fontSize
                  // We have added the ability to set the fontSize in the editor
                  minHeight: '490px',
                  maxHeight: '490px',
                  overflow: 'auto',
                  fontWeight: '600',
                }}
                editorClassName="slide5"
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            sx={{
              padding: '10px',
              transform: 'scale(1)',
              transformOrigin: 'top left',
              height: '100%',
              width: '58%',
            }}
          >
            <ModelSetField
              slide={slide}
              item={getSlideField(slide, 'modelSet')?.value}
              handleChange={onChangeSlide}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ marginBottom: '12px ', height: '40px' }}>
          <Typography
            sx={{ fontSize: '10px', color: '#7D7D7D', fontWeight: '400' }}
          >
            AssetMark US/Global Market Blend is the default option for Core
            exposure in cases where an adviser has identified cost as a factor
            in the decision-making process and to the extent that an adviser is
            not seeking tactical, actively-managed, factor-based or
            socially-focused Core exposure. The consideration of AssetMark
            proprietary strategies, including strategies managed by AssetMark,
            during the investment consulting process creates a conflict of
            interest for AssetMark as AssetMark receives fees for the management
            of those strategies and funds.
          </Typography>
        </Grid>
        <Footer
          numberPage={String(pageNumber)}
          text="For Financial Advisor use only"
        />
      </Grid>
    );
  },
);

export default Slide5Content;

const ModelSetField = ({ item }: any) => {
  console.log(item);
  return (
    <Grid item xs={12}>
      {/* <ModelSetSlideTable
        slideMode
        action={{
          id: '',
          caseId: '',
          userId: '',
          milestoneId: '',
          versionName: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          draft: false,
          value: { model_set_holdings: [item] },
        }}
        fontSize={12}
        enableCollapse
        modelSetName={item.model_set_name || ''}
      /> */}

      <SplitModelSetSlideTable
        data={{
          id: '',
          caseId: '',
          userId: '',
          milestoneId: '',
          versionName: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          draft: false,
          value: { model_set_holdings: [item] },
        }}
        modelSetName={item.model_set_name || ''}
        slideMode={true}
        fontSize={12}
        enableCollapse={true}
      />

      {/* <PremiumReportModelSetSlideTable
        action={{
          id: '',
          caseId: '',
          userId: '',
          milestoneId: '',
          versionName: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          draft: false,
          value: { model_set_holdings: [item] },
        }}
        modelSetName={item.model_set_name || ''}
        slideMode={true}
        groupHeaderHeight={56}
        columnHeaderHeight={32}
        rowHeight={36}
        fontSize={12}
      /> */}
    </Grid>
  );
};
